import { type ReactElement } from 'react';
import { roundTo } from '@optimization/ssi-common';
import { NotAvailable } from '../../../NotAvailable';
import styles from './style.module.scss';

const UNIT = 'kWh/km';

interface CycledEnergyCellProperties {
  readonly cycledEnergyPerKmAlert: boolean;
  readonly cycledEnergyPerKm?: number;
  readonly unavailable?: boolean;
}

const formatCycledEnergyPerKm = (cycledEnergyPerKm: number): string => roundTo(cycledEnergyPerKm, 1).toFixed(1);

const CycledEnergyPerKmCell = ({
  cycledEnergyPerKmAlert,
  cycledEnergyPerKm,
  unavailable = false,
}: CycledEnergyCellProperties): ReactElement => {
  if (unavailable || typeof cycledEnergyPerKm !== 'number') {
    return (
      <div className={styles.content} data-testid="cycled-energy-per-km-cell">
        <NotAvailable label={unavailable ? 'Not available' : 'N/A'} />
      </div>
    );
  }

  const formatted = formatCycledEnergyPerKm(cycledEnergyPerKm);

  if (cycledEnergyPerKmAlert) {
    return (
      <div className={styles.content} data-testid="cycled-energy-per-km-cell">
        <span className="tds-text-warning">
          {formatted} {UNIT}
        </span>
      </div>
    );
  }

  return (
    <div className={styles.content} data-testid="cycled-energy-per-km-cell">
      {formatted} <span className="tds-text-grey-350">{UNIT}</span>
    </div>
  );
};

export default CycledEnergyPerKmCell;
